const getDokument = [
  {
    id: '1',
    name: 'Raiffeisen stavební spořitelna a.s.',
    size: '224 KB',
    source: 'https://www.jhavelfinance.cz/public/dokumenty/rss.png',
  },
  {
    id: '2',
    name: 'Česká spořitelna a.s.',
    size: '720,7 KB',
    source: 'https://www.jhavelfinance.cz/public/dokumenty/cs.png',
  },
  {
    id: '3',
    name: 'Komerční banka a.s.',
    size: '304.1 KB',
    source: 'https://www.jhavelfinance.cz/public/dokumenty/kb.png',
  },
  {
    id: '4',
    name: 'Unicredit Bank a.s.',
    size: '219.7 KB',
    source: 'https://www.jhavelfinance.cz/public/dokumenty/ub.png',
  },
  {
    id: '5',
    size: '736.3 KB',
    name: 'Stavební spořitelna České spořitelny, a.s.',
    source: 'https://www.jhavelfinance.cz/public/dokumenty/sscs.png',
  },
  {
    id: '6',
    name: 'Československá obchodní banka, a.s.',
    size: '217 KB',
    source: 'https://www.jhavelfinance.cz/public/dokumenty/csob.png',
  },
  {
    id: '7',
    name: 'Wüstenrot - stavební spořitelna, a.s., Wüstenrot - Hypoteční banka, a.s.',
    size: '307 KB',
    source: 'https://www.jhavelfinance.cz/public/dokumenty/wustenrot.png',
  },
  // {
  //   id: '8',
  //   name: 'Modrá pyramida a.s.',
  //   size: '70.5 KB',
  //   source: 'https://www.jhavelfinance.cz/public/dokumenty/mp.png',
  // },
];

export default getDokument;
